import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import BorderButton from '../../../../../../components/light-weight/BorderButton';

const useStyles = makeStyles(() => ({
  root: {
    width: 32,
    minWidth: 32,

    '& .action-button-svg': {
      '&--menu': {
        width: 20,
        height: 20,
      },
    },
  },
}));

const ActionButtonMenu = ({ className = '', ...restProps }) => {
  const classes = useStyles();

  return (
    <BorderButton
      className={`${classes.root} ${className} action-button-menu`}
      {...restProps}
    >
      <MoreVertIcon className="action-button-svg action-button-svg--menu" />
    </BorderButton>
  );
};

export default ActionButtonMenu;
